module.exports = __webpack_public_path__ + "static/media/icon_menu.4a5e81b1.svg";